import { truncateMenuName } from './truncateMenuName';

export const boldMenuName = (name?: string | null) => (
  <strong style={{ fontWeight: 700 }}>{truncateMenuName(name)}</strong>
);
